// §11.6 / §9.1 — Settings as an in-process app.
//
// It is handed a `SettingsShellAccess` at composition (D-059) rather than reaching into the
// kernel, which `apps/**` may not do (§6.5). M3.9 ships Personalization; the remaining pages
// land in M13.7.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, SettingsShellAccess } from '@hangar/shared';
import { Settings } from './Settings';
import './settings.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createSettingsApp(access: SettingsShellAccess): InProcessApp {
  return {
    id: 'settings',
    name: 'Settings',
    icon: { glyph: 'settings', hue: 232 },
    keywords: ['personalization', 'wallpaper', 'accent', 'theme', 'skin', 'preferences'],
    window: { width: 760, height: 560, minWidth: 480, minHeight: 380 },

    mount(container) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Settings access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
